import { render } from "./CurrentPassword.vue?vue&type=template&id=0a4e0ddd"
import script from "./CurrentPassword.vue?vue&type=script&lang=js"
export * from "./CurrentPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__